import React from 'react'
import { Grid, Menu } from 'semantic-ui-react'

export default () => (
    <Menu secondary fixed="bottom" style={{ height: '55px' }}>
        <Grid style={{ margin: '1em 0em 0em', backgroundColor: "#333", color: '#ccc', width: '100%', textAlign: 'center' }}>
            <Grid.Row>
                <Grid.Column width={16} >
                    © 2019 BAINISYS
                </Grid.Column>
            </Grid.Row>
        </Grid>
    </Menu>
)


// WEBPACK FOOTER //
// ./src/features/ui/components/Footer.js